module.exports = __webpack_public_path__ + "static/media/logo.7750605e.png";